import React, { useRef, useEffect, useCallback } from "react";
import { KEYCODE_MAP } from "constants/keycode";
import { useCommandContext } from "utils/context/command";
import { BORDER_STYLE } from "./constants";
import { AUTO_ATTRS } from "components/Form/fields/constants";

const QueryInput = () => {
  const queryRef = useRef();
  useEffect(() => {
    queryRef.current && queryRef.current.focus();
  }, []);

  const {
    values,
    setFieldValue,
    activeId,
    actions: { popHistory, incrementIndex, decrementIndex, performIndex }
  } = useCommandContext();
  const { index: currentIndex, query } = values;

  /**
   * Reset index on query change
   */
  useEffect(() => {
    if (currentIndex) {
      setFieldValue("index", 0);
    }
  }, [query]);

  const resetQueryAndFocus = () => {
    setFieldValue("query", "");
    if (queryRef && queryRef.current) {
      queryRef.current.value = "";
      queryRef.current.focus();
    }
  };

  /**
   * Reset query on activeId change
   * - click on item without a perform
   * - or backspace on when theres no query value
   */
  useEffect(() => {
    resetQueryAndFocus();
  }, [activeId]);

  const onKeyDown = useCallback(
    (evt) => {
      const isBackspace = evt.keyCode === KEYCODE_MAP.BACKSPACE;
      const searchIsEmpty =
        queryRef && queryRef.current && !queryRef.current.value;
      const navigateBack = isBackspace && searchIsEmpty;
      if (navigateBack) {
        popHistory();
      } else if (evt.keyCode === KEYCODE_MAP.UP_ARROW) {
        decrementIndex();
      } else if (evt.keyCode === KEYCODE_MAP.DOWN_ARROW) {
        incrementIndex();
      } else if (evt.keyCode === KEYCODE_MAP.ENTER) {
        performIndex();
      }
    },
    [values]
  );

  const inputProps = {
    ref: queryRef,
    className:
      "input--muted f5 fw5 black-80 border-box input-reset ba pa3 db w-100 lh-copy bn brtl-2 brtr-2 absolute top-0 left-0 right-0",
    style: BORDER_STYLE,
    type: "text",
    name: "text",
    onKeyDown,
    /**
     * Note: used to used debounceOnChange here
     */
    onChange: (evt) => setFieldValue("query", evt.currentTarget.value),
    ...AUTO_ATTRS,
    placeholder: "Search..."
  };

  return <input {...inputProps} />;
};

export default QueryInput;
